export const DATA_QA = {
  CANCEL: 'dnc-record-delete-cancel',
  CONFIRM: 'dnc-record-delete-confirm',
} as const;
